import * as $runtime from "../runtime.js";
import * as Control$dBind from "../Control.Bind/index.js";
import * as Data$dArray from "../Data.Array/index.js";
import * as Data$dEither from "../Data.Either/index.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dFunction from "../Data.Function/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dLeibniz from "../Data.Leibniz/index.js";
import * as Data$dLoading from "../Data.Loading/index.js";
import * as Data$dMap$dInternal from "../Data.Map.Internal/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dTraversable from "../Data.Traversable/index.js";
import * as Effect$dClass from "../Effect.Class/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Foreign$dNullOrUndefined from "../Foreign.NullOrUndefined/index.js";
import * as Record$dExtra from "../Record.Extra/index.js";
import * as Restaumatic$dCommon$dTranslations$dKeys from "../Restaumatic.Common.Translations.Keys/index.js";
import * as Restaumatic$dForm$dFinal from "../Restaumatic.Form.Final/index.js";
import * as Restaumatic$dForm$dInternal from "../Restaumatic.Form.Internal/index.js";
import * as Restaumatic$dForm$dQuery from "../Restaumatic.Form.Query/index.js";
import * as Restaumatic$dForm$dResult from "../Restaumatic.Form.Result/index.js";
import * as Restaumatic$dForm$dTotality from "../Restaumatic.Form.Totality/index.js";
import * as Restaumatic$dForm$dValue from "../Restaumatic.Form.Value/index.js";
import * as Restaumatic$dI18n from "../Restaumatic.I18n/index.js";
import * as Restaumatic$dI18n$dTranslationKeys from "../Restaumatic.I18n.TranslationKeys/index.js";
import * as Specular$dFRP$dBase from "../Specular.FRP.Base/index.js";
import * as Specular$dFRP$dHost from "../Specular.FRP.Host/index.js";
import * as Specular$dInternal$dIncremental from "../Specular.Internal.Incremental/index.js";
import * as Specular$dInternal$dIncremental$dNode from "../Specular.Internal.Incremental.Node/index.js";
import * as Specular$dInternal$dRIO from "../Specular.Internal.RIO/index.js";
import * as Specular$dRef from "../Specular.Ref/index.js";
import * as Type$dEquality from "../Type.Equality/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
const from = a => a;
const valueIsSymbol = {reflectSymbol: () => "value"};
const touchedIsSymbol = {reflectSymbol: () => "touched"};
const encodeWithOptionsOther = {encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce};
const readValueIsSymbol = {reflectSymbol: () => "readValue"};
const encodeWithOptionsOther1 = {encodeWithOptions: v => Foreign$dGeneric$dClass.identity};
const readValidationErrorsIsSymbol = {reflectSymbol: () => "readValidationErrors"};
const encodeWithOptionsOther2 = /* #__PURE__ */ (() => {
  const encode1 = Data$dFunctor.arrayMap(Unsafe$dCoerce.unsafeCoerce);
  return {encodeWithOptions: v => encode1};
})();
const displayedErrorsIsSymbol = {reflectSymbol: () => "displayedErrors"};
const defaultValueIsSymbol = {reflectSymbol: () => "defaultValue"};
const sequenceRecord = /* #__PURE__ */ Record$dExtra.sequenceRecord()(/* #__PURE__ */ Record$dExtra.sequenceRecordCons(defaultValueIsSymbol)()(Specular$dFRP$dBase.applyDynamic)(/* #__PURE__ */ Record$dExtra.sequenceRecordCons(displayedErrorsIsSymbol)()(Specular$dFRP$dBase.applyDynamic)(/* #__PURE__ */ Record$dExtra.sequenceRecordCons(readValidationErrorsIsSymbol)()(Specular$dFRP$dBase.applyDynamic)(/* #__PURE__ */ Record$dExtra.sequenceRecordCons(readValueIsSymbol)()(Specular$dFRP$dBase.applyDynamic)(/* #__PURE__ */ Record$dExtra.sequenceRecordCons(touchedIsSymbol)()(Specular$dFRP$dBase.applyDynamic)(/* #__PURE__ */ Record$dExtra.sequenceRecordSingle(valueIsSymbol)()(Specular$dFRP$dBase.functorDynamic)()())()())()())()())()())()());
const $$new = /* #__PURE__ */ Specular$dRef.new(Effect$dClass.monadEffectEffect);
const identity = x => x;
const newEvent = /* #__PURE__ */ Specular$dFRP$dBase.newEvent(Effect$dClass.monadEffectEffect);
const show = /* #__PURE__ */ Data$dShow.showArrayImpl(Data$dShow.showStringImpl);
const foldMap = /* #__PURE__ */ (() => Data$dFoldable.foldableArray.foldMap(Restaumatic$dForm$dFinal.monoidFormErrors))();
const sequence = /* #__PURE__ */ (() => Data$dTraversable.traversableArray.traverse(Specular$dFRP$dBase.applicativeDynamic)(Data$dTraversable.identity))();
const defineForm = /* #__PURE__ */ Specular$dFRP$dHost.liftHost(Specular$dFRP$dHost.monadCleanupHost)(Specular$dInternal$dRIO.monadEffectRIO);
const FormField = x => x;
const mergeFormField$p = dictTypeEquals => {
  const to = dictTypeEquals.proof(a => a);
  return {
    merge: x => v => {
      const $0 = Restaumatic$dForm$dInternal.$TypedValue("Valid", {value: to(x), editValue: Data$dMaybe.Nothing});
      return v.value._2(_old => $0);
    }
  };
};
const initializeSomeInitialValu = dictInitialize => ({makeImpl: Restaumatic$dForm$dInternal.makeWithInitialValueIniti1(dictInitialize).makeWithInitialValueInitializer});
const initializeNoInitializerFo = dictInitialize => ({makeImpl: Restaumatic$dForm$dInternal.makeWithDefaultInitializer(dictInitialize)([])});
const initializeNoInitialValueI = dictInitialize => ({makeImpl: Restaumatic$dForm$dInternal.makeWithInitialValueIniti(dictInitialize).makeWithInitialValueInitializer});
const initializeEffectInitializ = dictInitialize => ({makeImpl: Restaumatic$dForm$dInternal.makeWithEffectInitializer(dictInitialize)});
const initializeContextInitiali = dictAddContext => dictInitialize => ({makeImpl: Restaumatic$dForm$dInternal.makeWithContextInitializer(dictInitialize)(dictAddContext)});
const hasContextFormField$p = {getContext: v => v.context._1};
const addContextFormField$p = {addContext: ctx => v => v.context._2(v1 => Data$dMap$dInternal.unsafeUnionWith(Data$dOrd.ordInt.compare, Data$dFunction.const, ctx, v1))};
const writeValue = v => v1 => {
  const $0 = v.onWriteValue;
  return () => {
    const handler = $0.value;
    return handler(v)(v1)();
  };
};
const writeValidValue = field => value => {
  const $0 = field.onWriteValue;
  return () => {
    const handler = $0.value;
    return handler(field)(Restaumatic$dForm$dInternal.$TypedValue("Valid", {value, editValue: Data$dMaybe.Nothing}))();
  };
};
const valueStateToResult = name => valueState => errors => {
  const $0 = Restaumatic$dForm$dResult.functorResult.map(from)((() => {
    if (valueState.tag === "Undefined") {
      return Restaumatic$dForm$dResult.$Result(
        Data$dLoading.Loaded,
        Restaumatic$dForm$dFinal.userVisibleErrors([
          Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dCommon$dTranslations$dKeys.t.form.errors.required), {})
        ]),
        valueState._1.lastValid
      );
    }
    if (valueState.tag === "Valid") {
      return Restaumatic$dForm$dResult.$Result(
        Data$dLoading.Loaded,
        Restaumatic$dForm$dFinal.monoidFormErrors.mempty,
        Restaumatic$dForm$dValue.$Value("SomeValue", valueState._1.value)
      );
    }
    if (valueState.tag === "Invalid") { return Restaumatic$dForm$dResult.$Result(Data$dLoading.Loaded, valueState._1.error, valueState._1.lastValid); }
    $runtime.fail();
  })());
  return Restaumatic$dForm$dResult.$Result(
    $0._1,
    Restaumatic$dForm$dInternal.tagErrors(name)(Data$dMap$dInternal.unsafeUnionWith(Restaumatic$dForm$dFinal.ordMaybe.compare, Data$dFunction.const, $0._2, errors)),
    $0._3
  );
};
const userEdit = v => v.userEdit.event;
const touch = v => v.touched._2(_old => true);
const readValueState = v => v.readValueState;
const isTextFieldFormField$p = dictEditAsString => (
  {
    textInput: field => (
      {
        displayedValue: Specular$dFRP$dBase.functorDynamic.map(v => {
          if (v.tag === "Undefined") { return ""; }
          if (v.tag === "Invalid") {
            if (v._1.editValue.tag === "Nothing") { return ""; }
            if (v._1.editValue.tag === "Just") { return v._1.editValue._1; }
            $runtime.fail();
          }
          if (v.tag === "Valid") {
            if (v._1.editValue.tag === "Just") { return v._1.editValue._1; }
            if (v._1.editValue.tag === "Nothing") { return dictEditAsString.toString(v._1.value); }
            $runtime.fail();
          }
          $runtime.fail();
        })(field.readValueState),
        onChange: str => {
          const v = dictEditAsString.parse(str);
          const $0 = (() => {
            if (v.tag === "Left") {
              return Restaumatic$dForm$dInternal.$TypedValue(
                "Invalid",
                {
                  error: Restaumatic$dForm$dFinal.userVisibleErrors([v._1]),
                  lastValid: Restaumatic$dForm$dValue.$Value("NoValue", Data$dLeibniz.refl),
                  editValue: Data$dMaybe.$Maybe("Just", str)
                }
              );
            }
            if (v.tag === "Right") { return Restaumatic$dForm$dInternal.$TypedValue("Valid", {value: v._1, editValue: Data$dMaybe.$Maybe("Just", str)}); }
            $runtime.fail();
          })();
          const $1 = field.onWriteValue;
          return () => {
            const handler = $1.value;
            return handler(field)($0)();
          };
        },
        onTouch: field.touched._2(_old => true),
        placeholder: (() => {
          const n = Specular$dInternal$dIncremental.constant("");
          Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
          return n;
        })()
      }
    )
  }
);
const queryFormField$p = dictTypeEquals => {
  const from1 = dictTypeEquals.proof(a => a);
  return {
    queryImpl: v => v1 => {
      if (v.tag === "Lax") {
        return Specular$dFRP$dBase.functorDynamic.map(v2 => Restaumatic$dForm$dResult.functorResult.map(from1)(valueStateToResult(v1.name)(v2)(Restaumatic$dForm$dFinal.monoidFormErrors.mempty)))(v1.readValueState);
      }
      if (v.tag === "Strict") { return Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dForm$dResult.functorResult.map(from1))(v1.cachedQuery); }
      $runtime.fail();
    }
  };
};
const queryImpl = /* #__PURE__ */ (() => queryFormField$p(Type$dEquality.refl).queryImpl)();
const readValueF = field => Specular$dFRP$dBase.functorDynamic.map(v => {
  if (v.tag === "Undefined") {
    return Data$dEither.$Either(
      "Left",
      Restaumatic$dForm$dFinal.userVisibleErrors([
        Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dCommon$dTranslations$dKeys.t.form.errors.required), {})
      ])
    );
  }
  if (v.tag === "Valid") { return Data$dEither.$Either("Right", v._1.value); }
  if (v.tag === "Invalid") { return Data$dEither.$Either("Left", v._1.error); }
  $runtime.fail();
})(field.readValueState);
const validations = v => v1 => {
  const $0 = Data$dFunctor.arrayMap(v2 => v2(readValueF(v1)))(v);
  return v1.validations._2(_old => $0);
};
const isCheckboxFieldFormField$p = {
  checkboxInput: v => {
    const $0 = Specular$dFRP$dBase.readDynamic(Effect$dClass.monadEffectEffect)(Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dForm$dFinal.fromValidV)(readValueF(v)));
    return () => {
      const initial = $0();
      const $1 = v.value._2(_old => Restaumatic$dForm$dInternal.$TypedValue("Valid", {value: false, editValue: Data$dMaybe.Nothing}));
      if (
        (() => {
          if (initial.tag === "Nothing") { return true; }
          if (initial.tag === "Just") { return false; }
          $runtime.fail();
        })()
      ) {
        $1();
      }
      return {
        displayedValue: Specular$dFRP$dBase.functorDynamic.map(v2 => {
          if (v2.tag === "Nothing") { return false; }
          if (v2.tag === "Just") { return v2._1; }
          $runtime.fail();
        })(Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dForm$dFinal.fromValidV)(readValueF(v))),
        onChange: writeValidValue(v)
      };
    };
  }
};
const isRefLikeFormField$p = {
  readRefLike: f => Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dForm$dFinal.fromValidV)(readValueF(f)),
  writeRefLike: writeValue,
  touchRefLike: touch
};
const mergeInputRequiredFormFie = {
  mergeInputRequired: field => {
    const $0 = Restaumatic$dForm$dInternal.$TypedValue(
      "Invalid",
      {
        error: Restaumatic$dForm$dFinal.userVisibleErrors([
          Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dCommon$dTranslations$dKeys.t.form.errors.required), {})
        ]),
        lastValid: Restaumatic$dForm$dValue.$Value("NoValue", Data$dLeibniz.refl),
        editValue: Data$dMaybe.Nothing
      }
    );
    const $1 = field.onWriteValue;
    return () => {
      const handler = $1.value;
      return handler(field)($0)();
    };
  }
};
const readValidationErrors = v => Specular$dFRP$dBase.functorDynamic.map((() => {
  const $0 = Data$dFunctor.arrayMap(v1 => v1.message);
  const $1 = Data$dArray.filter(x => !x.internal);
  const $2 = Data$dMap$dInternal.lookup(Data$dMaybe.ordMaybe(Data$dOrd.ordArray(Data$dOrd.ordString)))(Data$dMaybe.$Maybe("Just", v.name));
  return x => $0($1((() => {
    const $3 = $2(x);
    if ($3.tag === "Nothing") { return []; }
    if ($3.tag === "Just") { return $3._1; }
    $runtime.fail();
  })()));
})())(Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dForm$dResult.errors)(queryImpl(Restaumatic$dForm$dQuery.Strict)(v)));
const hasErrorsFormField$p = {
  displayedErrors: v => Specular$dFRP$dBase.applyDynamic.apply(Specular$dFRP$dBase.applyDynamic.apply(Specular$dFRP$dBase.functorDynamic.map(v1 => v2 => v3 => {
    if (v1 || v2) { return v3; }
    return [];
  })(v.touched._1))(Specular$dFRP$dBase.functorDynamic.map(v2 => {
    if (v2.tag === "Nothing") { return false; }
    if (v2.tag === "Just") { return v2._1; }
    $runtime.fail();
  })(Restaumatic$dForm$dInternal.dynamicFromContext(hasContextFormField$p)(Restaumatic$dForm$dInternal.forceDisplayErrorsKey)(v))))(readValidationErrors(v))
};
const dumpStateFormField$p = dictEncode => {
  const encodeWithOptionsOther3 = {
    encodeWithOptions: v => v2 => {
      if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
      if (v2.tag === "Just") { return dictEncode.encode(v2._1); }
      $runtime.fail();
    }
  };
  return dictEncode1 => {
    const encode2 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(valueIsSymbol)((() => {
      const encode1 = dictEncode1.encode;
      return {encodeWithOptions: v => encode1};
    })()))(touchedIsSymbol)(encodeWithOptionsOther))(readValueIsSymbol)(encodeWithOptionsOther1))(readValidationErrorsIsSymbol)(encodeWithOptionsOther2))(displayedErrorsIsSymbol)(encodeWithOptionsOther2))(defaultValueIsSymbol)(encodeWithOptionsOther3).encodeRecordWithOptions(Type$dProxy.Proxy)(Foreign$dGeneric$dClass.defaultOptions);
    return {
      dumpState: v => Specular$dFRP$dBase.functorDynamic.map(encode2)(sequenceRecord({
        value: v.value._1,
        defaultValue: Specular$dFRP$dBase.bindDynamic.bind(v.defaultValue._1)(Restaumatic$dForm$dFinal.unFinal),
        touched: v.touched._1,
        readValue: Specular$dFRP$dBase.functorDynamic.map(v2 => {
          if (v2.tag === "Nothing") { return "(NO READ VALUE)"; }
          if (v2.tag === "Just") { return dictEncode.encode(v2._1); }
          $runtime.fail();
        })(Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dForm$dFinal.fromValidV)(readValueF(v))),
        readValidationErrors: readValidationErrors(v),
        displayedErrors: hasErrorsFormField$p.displayedErrors(v)
      }))
    };
  };
};
const readOptions = () => v => Specular$dFRP$dBase.bindDynamic.bind(v.options._1)(optionsDef => Specular$dFRP$dBase.functorDynamic.map(v2 => {
  if (v2.tag === "Nothing") { return []; }
  if (v2.tag === "Just") { return v2._1; }
  $runtime.fail();
})(Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dForm$dFinal.fromValidV)(optionsDef)));
const isSelectFieldFormField$p = () => (
  {
    selectWriteValue: writeValidValue,
    selectReadValue: x => Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dForm$dFinal.fromValidV)(readValueF(x)),
    selectGetOptions: readOptions(),
    selectTouch: touch
  }
);
const options = () => v => v1 => v1.options._2(_old => v);
const onWriteValue = v => v1 => {
  const $0 = v1.onWriteValue;
  return () => $0.value = v;
};
const normalize = v => v1 => v1.normalize._2(_old => v);
const modifyValidValue = v => update => {
  const $0 = Specular$dFRP$dBase.readDynamic(Effect$dClass.monadEffectEffect)(Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dForm$dFinal.fromValidV)(readValueF(v)));
  return () => {
    const old = $0();
    const handler = v.onWriteValue.value;
    handler(v)(Restaumatic$dForm$dInternal.$TypedValue("Valid", {value: update(old), editValue: Data$dMaybe.Nothing}))();
    v.touched._2(_old => true)();
    return v.userEdit.fire()();
  };
};
const modify = v => update => {
  const $0 = Specular$dFRP$dBase.readDynamic(Effect$dClass.monadEffectEffect)(Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dForm$dFinal.fromValidV)(readValueF(v)));
  return () => {
    const old = $0();
    if (old.tag === "Nothing") { return; }
    if (old.tag === "Just") {
      const handler = v.onWriteValue.value;
      handler(v)(Restaumatic$dForm$dInternal.$TypedValue("Valid", {value: update(old._1), editValue: Data$dMaybe.Nothing}))();
      v.touched._2(_old => true)();
      return v.userEdit.fire()();
    }
    $runtime.fail();
  };
};
const getLastValid = v => {
  if (v.tag === "Undefined") { return v._1.lastValid; }
  if (v.tag === "Invalid") { return v._1.lastValid; }
  if (v.tag === "Valid") { return Restaumatic$dForm$dValue.$Value("SomeValue", v._1.value); }
  $runtime.fail();
};
const fieldNameString = v => Restaumatic$dForm$dInternal.fieldPathToString(v.name);
const hasFieldIdFormField$p = {getFieldId: fieldNameString};
const defaultValue = v => v1 => v1.defaultValue._2(_old => v);
const copyStateFormField = {
  copyState: v => v1 => {
    const $0 = Specular$dFRP$dBase.readDynamic(Effect$dClass.monadEffectEffect)(v.value._1);
    const $1 = v1.value;
    return () => {
      const $2 = $0();
      return $1._2(_old => $2)();
    };
  }
};
const augmentWithLastValid = v => v1 => {
  if (v.tag === "Undefined") {
    return Restaumatic$dForm$dInternal.$TypedValue(
      "Undefined",
      {
        ...v._1,
        lastValid: (() => {
          const $0 = getLastValid(v1);
          if (v._1.lastValid.tag === "SomeValue") { return Restaumatic$dForm$dValue.$Value("SomeValue", v._1.lastValid._1); }
          if (v._1.lastValid.tag === "NoValue") { return $0; }
          $runtime.fail();
        })()
      }
    );
  }
  if (v.tag === "Invalid") {
    return Restaumatic$dForm$dInternal.$TypedValue(
      "Invalid",
      {
        ...v._1,
        lastValid: (() => {
          const $0 = getLastValid(v1);
          if (v._1.lastValid.tag === "SomeValue") { return Restaumatic$dForm$dValue.$Value("SomeValue", v._1.lastValid._1); }
          if (v._1.lastValid.tag === "NoValue") { return $0; }
          $runtime.fail();
        })()
      }
    );
  }
  if (v.tag === "Valid") { return Restaumatic$dForm$dInternal.$TypedValue("Valid", v._1); }
  $runtime.fail();
};
const defaultWriteValue = v => v1 => {
  const $0 = v.value._2(augmentWithLastValid(v1));
  return () => {
    $0();
    v.touched._2(_old => true)();
    return v.userEdit.fire()();
  };
};
const unsafeNewEmptyFormField = dictIsTotality => opts => {
  const $0 = $$new(Restaumatic$dForm$dFinal.invalidFinal);
  return () => {
    const label_ = $0();
    const value = $$new(Restaumatic$dForm$dInternal.$TypedValue("Undefined", {lastValid: Restaumatic$dForm$dValue.$Value("NoValue", Data$dLeibniz.refl)}))();
    const defaultValue1 = $$new((() => {
      const $1 = Data$dEither.$Either(
        "Left",
        Restaumatic$dForm$dFinal.userVisibleErrors([
          Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dCommon$dTranslations$dKeys.t.form.errors.required), {})
        ])
      );
      return (() => {
        const n = Specular$dInternal$dIncremental.constant($1);
        Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
        return n;
      })();
    })())();
    const touched = $$new(false)();
    const options1 = $$new(Restaumatic$dForm$dFinal.applicativeFinal.pure([]))();
    const validations1 = $$new([])();
    const context = $$new(Data$dMap$dInternal.Leaf)();
    const normalize1 = $$new((() => {
      const n = Specular$dInternal$dIncremental.constant(identity);
      Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
      return n;
    })())();
    const userEdit1 = newEvent();
    const onWriteValue_ = {value: defaultWriteValue};
    const $1 = "FormField.readValueState " + show(opts.name);
    const $2 = Specular$dFRP$dBase.applyDynamic.apply(Specular$dFRP$dBase.applyDynamic.apply(Specular$dFRP$dBase.functorDynamic.map(v => v1 => v2 => {
      if (v2.tag === "Undefined") {
        if (v.tag === "Left") {
          return Restaumatic$dForm$dInternal.$TypedValue(
            "Invalid",
            {
              error: Data$dMap$dInternal.unsafeUnionWith(
                Restaumatic$dForm$dFinal.ordMaybe.compare,
                Data$dFunction.const,
                Restaumatic$dForm$dFinal.userVisibleErrors([
                  Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dCommon$dTranslations$dKeys.t.form.errors.required), {})
                ]),
                v._1
              ),
              lastValid: v2._1.lastValid,
              editValue: Data$dMaybe.Nothing
            }
          );
        }
        if (v.tag === "Right") { return Restaumatic$dForm$dInternal.$TypedValue("Valid", {value: v._1, editValue: Data$dMaybe.Nothing}); }
        $runtime.fail();
      }
      if (v2.tag === "Valid") { return Restaumatic$dForm$dInternal.$TypedValue("Valid", {value: v1(v2._1.value), editValue: v2._1.editValue}); }
      return v2;
    })(Specular$dFRP$dBase.bindDynamic.bind(defaultValue1._1)(Restaumatic$dForm$dFinal.unFinalV)))(Specular$dFRP$dBase.bindDynamic.bind(normalize1._1)(Control$dBind.identity)))(value._1);
    const readValueState_ = (() => {
      Specular$dInternal$dIncremental$dNode.annotate($2, $1);
      return $2;
    })();
    const extractErrors = foldMap(v2 => {
      if (v2.tag === "Left") { return v2._1; }
      if (v2.tag === "Right") {
        if (v2._1.length === 0) { return Restaumatic$dForm$dFinal.monoidFormErrors.mempty; }
        return Data$dMap$dInternal.$$$Map(
          "Node",
          1,
          1,
          Data$dMaybe.$Maybe("Just", opts.name),
          Data$dFunctor.arrayMap(message => ({fieldName: Data$dMaybe.$Maybe("Just", opts.name), fieldLabel: Data$dMaybe.Nothing, message, internal: false}))(v2._1),
          Data$dMap$dInternal.Leaf,
          Data$dMap$dInternal.Leaf
        );
      }
      $runtime.fail();
    });
    Specular$dInternal$dIncremental$dNode.annotate(value._1, "FormField.value");
    Specular$dInternal$dIncremental$dNode.annotate(touched._1, "FormField.touched");
    return {
      name: opts.name,
      label: label_,
      value,
      defaultValue: defaultValue1,
      touched,
      options: options1,
      validations: validations1,
      context,
      normalize: normalize1,
      userEdit: userEdit1,
      readValueState: readValueState_,
      onWriteValue: onWriteValue_,
      isTotal: dictIsTotality.isTotal(Type$dProxy.Proxy),
      cachedQuery: Specular$dFRP$dBase.applyDynamic.apply(Specular$dFRP$dBase.functorDynamic.map(v => v1 => valueStateToResult(opts.name)(v1)(extractErrors(v)))(Specular$dFRP$dBase.bindDynamic.bind(validations1._1)(validations$p => sequence(Data$dFunctor.arrayMap(Restaumatic$dForm$dFinal.unFinalV)(validations$p)))))(readValueState_)
    };
  };
};
const initializeSomeInitialValu1 = dictIsTotality => dictTypeEquals => {
  const to = dictTypeEquals.proof(a => a);
  return dictTypeEquals1 => {
    const merge = mergeFormField$p(dictTypeEquals1).merge;
    return {
      makeImpl: v => opts => {
        const $0 = unsafeNewEmptyFormField(dictIsTotality)(opts);
        return () => {
          const field = $0();
          return {
            field,
            init: v1 => {
              const $1 = v1._1;
              return initializer => Specular$dInternal$dRIO.bindImpl(merge($1)(field))(() => defineForm(Restaumatic$dForm$dInternal.traverse_(v$1 => v$1(field))(Data$dFunctor.arrayMap(to)(initializer))));
            }
          };
        };
      }
    };
  };
};
const initializeNoInitialValueA = dictTypeEquals => {
  const makeImpl = initializeSomeInitialValu1(Restaumatic$dForm$dTotality.isTotalityTotal)(dictTypeEquals)(Type$dEquality.refl).makeImpl;
  return dictHasDefaultValue => {
    const defaultValue1 = dictHasDefaultValue.defaultValue;
    return {
      makeImpl: p => opts => Specular$dInternal$dRIO.bindImpl(makeImpl(p)(opts))(v => Specular$dInternal$dRIO.pureImpl({
        field: v.field,
        init: v1 => v.init(Restaumatic$dForm$dInternal.$SomeInitialValue(defaultValue1))
      }))
    };
  };
};
const makeEmptyFormField$pPartia = {makeEmptyImpl: /* #__PURE__ */ unsafeNewEmptyFormField(Restaumatic$dForm$dTotality.isTotalityPartial)};
const initializeNoInitialValueA1 = dictTypeEquals => {
  const to = dictTypeEquals.proof(a => a);
  return {
    makeImpl: v => opts => Specular$dInternal$dRIO.bindImpl(unsafeNewEmptyFormField(Restaumatic$dForm$dTotality.isTotalityPartial)(opts))(field => Specular$dInternal$dRIO.pureImpl({
      field,
      init: v1 => initializer => defineForm(Restaumatic$dForm$dInternal.traverse_(v$1 => v$1(field))(Data$dFunctor.arrayMap(to)(initializer)))
    }))
  };
};
const writeValueNoTouch = v => v1 => {
  const $0 = v.value._2(augmentWithLastValid(v1));
  return () => {
    $0();
    return v.userEdit.fire()();
  };
};
export {
  FormField,
  addContextFormField$p,
  augmentWithLastValid,
  copyStateFormField,
  defaultValue,
  defaultValueIsSymbol,
  defaultWriteValue,
  defineForm,
  displayedErrorsIsSymbol,
  dumpStateFormField$p,
  encodeWithOptionsOther,
  encodeWithOptionsOther1,
  encodeWithOptionsOther2,
  fieldNameString,
  foldMap,
  from,
  getLastValid,
  hasContextFormField$p,
  hasErrorsFormField$p,
  hasFieldIdFormField$p,
  identity,
  initializeContextInitiali,
  initializeEffectInitializ,
  initializeNoInitialValueA,
  initializeNoInitialValueA1,
  initializeNoInitialValueI,
  initializeNoInitializerFo,
  initializeSomeInitialValu,
  initializeSomeInitialValu1,
  isCheckboxFieldFormField$p,
  isRefLikeFormField$p,
  isSelectFieldFormField$p,
  isTextFieldFormField$p,
  makeEmptyFormField$pPartia,
  mergeFormField$p,
  mergeInputRequiredFormFie,
  modify,
  modifyValidValue,
  $$new as new,
  newEvent,
  normalize,
  onWriteValue,
  options,
  queryFormField$p,
  queryImpl,
  readOptions,
  readValidationErrors,
  readValidationErrorsIsSymbol,
  readValueF,
  readValueIsSymbol,
  readValueState,
  sequence,
  sequenceRecord,
  show,
  touch,
  touchedIsSymbol,
  unsafeNewEmptyFormField,
  userEdit,
  validations,
  valueIsSymbol,
  valueStateToResult,
  writeValidValue,
  writeValue,
  writeValueNoTouch
};
